import React, { useState } from 'react'
import Button from '@mostrans/web-components/components/base/Button'
import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography } from '@mui/material'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import PreviewIcon from '@mui/icons-material/Preview';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import "./assets/stylePreviewProfile.css"
import { formatNumber } from '../../../../function/FormatNumber';

function ModalPdfProfile(props) {
    const [openModalPreviewPDF, setOpenModalPreviewPDF] = useState(false)
    const { dataCandidateByID } = props

    const handleModalOpen = () => {
        setOpenModalPreviewPDF(true)
    }

    const handleModalClose = () => {
        setOpenModalPreviewPDF(false)
    }

    const createProfilePdf = () => {
        const input = document.getElementById('divToPrint');
        html2canvas(input,)
            .then((canvas) => {
                let imgWidth = 210;
                let imgHeight = canvas.height * imgWidth / canvas.width;
                const imgData = canvas.toDataURL('img/png');
                const pdf = new jsPDF('p', 'mm', 'a4');
                pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
                pdf.save("profile.pdf");
            })
    }

    return (
        <React.Fragment>
            <Button
                color="primary"
                startIcon={<PreviewIcon />}
                onClick={handleModalOpen}
            >
                Preview to Export
            </Button>
            <Dialog open={openModalPreviewPDF} onClose={handleModalClose} fullWidth maxWidth="xl">
                <DialogTitle>
                    Preview Profile To Export
                </DialogTitle>
                <DialogContent>
                    <div className="row">
                        <div className="col-md-12" style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Button
                                color="primary"
                                startIcon={<FileDownloadOutlinedIcon />}
                                onClick={createProfilePdf}
                            >
                                Save to PDF
                            </Button>
                        </div>
                    </div>
                    <div className="book">
                        <div className="page" id='divToPrint'>
                            <div className="subpage">
                                <div className="row">
                                    <div className="col-md-5 left" style={{ backgroundColor: "#223f4f", marginLeft: "-3px" }}>
                                        <Typography variant='h5' className='text text-title top-text'>
                                            Contact
                                        </Typography>
                                        <Typography className='text text-content'>
                                            {dataCandidateByID?.email}
                                        </Typography>
                                        <Typography className='text text-content'>
                                            {dataCandidateByID?.phone_number}
                                        </Typography>
                                        <Typography variant='h5' className='text text-title'>
                                            Date of Birth
                                        </Typography>
                                        <Typography className='text text-content'>
                                            {dataCandidateByID?.birth_date.split(",")[0]}
                                        </Typography>
                                        <Typography variant='h5' className='text text-title'>
                                            Address
                                        </Typography>
                                        <Typography className='text text-content'>
                                            {dataCandidateByID?.address}
                                        </Typography>
                                        <Typography variant='h5' className='text text-title'>
                                            Skills
                                        </Typography>
                                        {dataCandidateByID?.skills
                                            ? dataCandidateByID.skills?.map((skill, index) => (
                                                <Typography className='text text-content' key={index}>
                                                    {skill}
                                                </Typography>
                                            ))
                                            : (<Typography className='text text-content'>
                                                -
                                            </Typography>)}
                                    </div>
                                    <div className="col-md-7 right">
                                        <Typography sx={{ fontWeight: "150px", fontSize: "40px" }} className="top-text">
                                            {dataCandidateByID?.full_name}
                                        </Typography>
                                        <Divider />
                                        <Typography variant='h5' style={{ marginTop: "15px" }}>
                                            Experience
                                        </Typography>
                                        {dataCandidateByID?.Experiences
                                            ? dataCandidateByID.Experiences?.map((experience) => (
                                                <div key={experience.id} className="mb-1">
                                                    <Typography sx={{ fontSize: 12, fontWeight: 600 }}>
                                                        {experience?.company}
                                                    </Typography> <Typography sx={{ fontSize: 12, fontWeight: 600 }}>
                                                        {experience?.job_position}
                                                    </Typography>
                                                    <Typography variant="subtitle2" color="GrayText">
                                                        ({experience.start_date?.split(",")[0]} -{" "}
                                                        {experience.is_current === false
                                                            ? experience.end_date?.split(",")[0]
                                                            : "Now"}
                                                        )
                                                    </Typography>
                                                </div>
                                            ))
                                            : <Typography variant="subtitle2">-</Typography>}
                                        <Typography variant='h5' style={{ marginTop: "15px" }}>
                                            Education
                                        </Typography>
                                        {dataCandidateByID.Educations?.map((education) => (
                                            <div key={education.id} className="mb-1">
                                                <Typography sx={{ fontSize: 12, fontWeight: 600 }}>
                                                    {education.degree ? education.degree : "-"} of{" "}
                                                    {education.major}
                                                </Typography>
                                                <Typography
                                                    variant="subtitle2"
                                                    sx={{ fontSize: 12 }}
                                                    color="GrayText"
                                                >
                                                    {education.school_name}{" "}
                                                    {education.is_current === false ? (
                                                        <div style={{ display: "flex" }}>
                                                            <p>Start Year : {education.start_year}</p>&nbsp; -&nbsp;
                                                            <p>Graduated : {education.graduate_year}</p>
                                                        </div>
                                                    ) : (
                                                        <p>Not Graduated</p>
                                                    )}
                                                </Typography>
                                            </div>
                                        ))}
                                        <Typography variant='h5' style={{ marginTop: "15px" }}>
                                            Salary Info
                                        </Typography>
                                        <Typography variant="subtitle2" color="GrayText">
                                            Current Salary :{" "}
                                            {dataCandidateByID?.curr_salary ? (
                                                <p>Rp. {formatNumber(dataCandidateByID?.curr_salary)}</p>
                                            ) : (
                                                "-"
                                            )}{" "}
                                            <br />
                                            Expected Salary :{" "}
                                            {dataCandidateByID?.expected_salary ? (
                                                <p>Rp. {formatNumber(dataCandidateByID?.expected_salary)}</p>
                                            ) : (
                                                "-"
                                            )}
                                        </Typography>
                                        <Typography variant='h5' style={{ marginTop: "15px" }}>
                                            Benefit Info
                                        </Typography>
                                        <Typography variant="subtitle2" color="GrayText">
                                            Current Benefits :
                                            {dataCandidateByID?.curr_benefits
                                                ? dataCandidateByID?.curr_benefits.map((benefit, index) => (
                                                    <li key={index}>{benefit}</li>
                                                ))
                                                : "-"}
                                            <br />
                                            Expected Benefits :
                                            {dataCandidateByID?.expected_benefits
                                                ? dataCandidateByID?.expected_benefits.map((benefit, index) => (
                                                    <li key={index}>{benefit}</li>
                                                ))
                                                : "-"}
                                        </Typography>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleModalClose} variant="contained" color="error">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

export default ModalPdfProfile